/**
 * Store Cabinets
 */
export default {
    actions: {
        uploadDocumentGed: function (context, payload) {
            let formData = new FormData()
            if (payload.id) {
                formData.append('id', payload.id)
            }
            if (payload.fichier) {
                formData.append('file', payload.fichier)
            }
            if (payload.lot_client_id) {
                formData.append('lot_client_id', payload.lot_client_id)
            }
            formData.append('dossier_id', payload.dossier_id)
            formData.append('ged_type_id', payload.ged_type_id)
            formData.append('is_recu', payload.is_recu)

            let headers = {'Content-Type': 'multipart/form-data'}
            axios.post('/api/ged', formData, { headers })
                .then(response => {
                    payload.successFunction(response.data)
                })
                .catch((error) => {
                    payload.errorFunction(error)
                })
        },

        updateDocumentGed: function(context, payload) {
            let formData = new FormData()
            if (payload.fichier) {
                formData.append('file', payload.fichier)
            }
            if (payload.lot_client_id) {
                formData.append('lot_client_id', payload.lot_client_id)
            }
            formData.append('dossier_id', payload.dossier_id)
            formData.append('id', payload.id)
            formData.append('ged_type_id', payload.ged_type_id)
            formData.append('is_recu', payload.is_recu)
            formData.append('nom', payload.nom)

            let headers = {'Content-Type': 'multipart/form-data'}
            axios.post('/api/ged/' + payload.id + '/ged-update?_method=PATCH', formData, { headers })
                .then(response => {

                    payload.successFunction(response.data)
                })
                .catch((error) => {
                    payload.errorFunction(error)
                })
        },

        uploadPieceJointe: function (context, payload) {
            let formData = new FormData()
            formData.append('file', payload.fichier)

            let headers = {'Content-Type': 'multipart/form-data'}

            axios.post('/api/piece-jointe', formData, { headers })
                .then(response => {
                    payload.successFunction(response.data.path)
                })
                .catch((error) => {
                    payload.errorFunction(error)
                })
        },

        saveFichier: function (context, payload) {
            axios.request({
                url: '/api/fichiers' + (payload.fichier.id ? '/' + payload.fichier.id : ''),
                method: payload.fichier.id ? 'patch' : 'post',
                data: payload.fichier
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            })
        },

        addLink: function (context, payload) {
            axios.request({
                url: '/api/fichiers-mails-types-cabinets',
                method: 'post',
                data: payload.link
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            })
        },

        removeLink: function (context, payload) {
            axios.request({
                url: '/api/fichiers-mails-types-cabinets/' + payload.id,
                method: 'delete',
                data: payload.fichier
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            })
        },
    }
}
